import React, { useEffect } from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import useDelete from '../customHooks/useDelete';
import { toast } from 'react-toastify';

const PopupBannerCard = ({ data, alldata, deleted, permission }) => {
  const {
    id,
    title,
    attachment_url,
    attachment,
    redirect_link,
    from_date,
    to_date,
    status,
  } = data;

  const [resDelete, apiMethodDelete] = useDelete();

  const handleDelete = () => {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure that you want to delete?',
      buttons: true,
      icon: 'warning',
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        apiMethodDelete(`popupBanner/${id}`);
      }
    });
  };

  useEffect(() => {
    if (resDelete.data) {
      const { message } = resDelete.data;
      const update = alldata.filter((item) => item.id !== id);
      deleted(update);
      toast.success(message);
    }
  }, [resDelete.data]);

  const check = (module, action) => {
    const moduleCandidates = [module, module.replace(/PopupBanner/g, 'Popup Banners'), module.replace(/Popup Banners/g, 'PopupBanner')];
    const actionCandidates = [action, action.replace(/PopupBanner/g, 'Popup Banner'), action.replace(/Popup Banner/g, 'PopupBanner')];
    return moduleCandidates.some((moduleName) =>
      actionCandidates.some((candidate) => permission?.[moduleName]?.includes(candidate))
    );
  };
  const imageSrc = attachment_url || attachment;

  return (
    <div className='BlogsCard group relative overflow-hidden rounded-[1.5rem] border border-[#D4DEF1] bg-white shadow-custom transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(18,38,63,0.10)]'>
      {check('PopupBanner', 'PopupBanner Delete') && (
        <button
          type="button"
          className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[2rem] h-[2rem] p-[.6rem] top-[.7rem] right-[.7rem] grid place-items-center rounded-[.7rem] z-10'
          onClick={handleDelete}
        >
          <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      )}
      <Link className="BlogsCardMain flex flex-col gap-4 p-4 lg:flex-row lg:items-center" to={`/popup-banner/edit/${id}`}>
        <div className="BlogsCard__left w-full lg:w-[12rem] lg:flex-none">
          <img src={imageSrc} className='h-[11rem] w-full rounded-[1.25rem] object-cover lg:h-[8rem]' alt={title || 'popup banner'} />
        </div>
        <div className="BlogsCard__leftRight min-w-0 flex-1 lg:pr-4">
          <div className="mb-2 max-h-[3.1rem] overflow-hidden text-[1.1rem] capitalize font-MluvkaLight leading-[1.2] text-[#101828] lg:text-[1.25rem]">{title}</div>
          <div className='text-[#475467] text-[.88rem] leading-[1.6] mb-2 break-words'>{redirect_link}</div>
          <ul className='list text-[.8rem] text-[#393946] space-y-1'>
            <li className='flex justify-between gap-2'>
              <span>From</span>
              <span>{from_date}</span>
            </li>
            <li className='flex justify-between gap-2'>
              <span>To</span>
              <span>{to_date}</span>
            </li>
            <li className='flex justify-between gap-2'>
              <span>Status</span>
              <span>{Number(status) === 1 ? 'Active' : 'Inactive'}</span>
            </li>
          </ul>
        </div>
        <div className="flex flex-row items-center justify-between gap-3 border-t border-[#EEF2F7] pt-4 lg:w-[10rem] lg:flex-col lg:items-end lg:justify-center lg:border-t-0 lg:pt-0 status-button">
          <span className="text-sm font-MluvkaBold text-[#0F172A]">Open</span>
          <span className="rounded-full bg-[#EFF4FD] px-4 py-2 text-sm font-MluvkaBold text-primary transition-colors group-hover:bg-primary group-hover:text-white">
            Edit
          </span>
        </div>
      </Link>
    </div>
  );
};

export default PopupBannerCard;


